import React, { useRef } from 'react'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyImage } from '~/components/ui/MyImage'
import { MyModal } from '~/components/ui/MyModal'
import {
  getBackImageList_squareModule_postBackImagePage_edges_node,
  deleteBackImage,
  deleteBackImageVariables,
} from '~/graphqls/types'
import styles from './PreviewBackImageModal.module.css'
import { DELETE_BACK_IMAGE } from '~/graphqls/gqls'
import { useMutation } from '@apollo/client'
import { graphQLErrorMessage } from '~/utils'
import { Modal, message } from 'antd'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'

export const PreviewBackImageModal: React.FC<{
  visible: boolean
  onCancel: () => void
  product: getBackImageList_squareModule_postBackImagePage_edges_node | null
  onSuccess?: () => void
}> = observer(({ visible, onCancel, product, onSuccess }) => {
  const contentRef = useRef<any>()
  const { store } = useStores()
  const [deleteAction] = useMutation<deleteBackImage, deleteBackImageVariables>(
    DELETE_BACK_IMAGE
  )
  const handleDelete = () => {
    Modal.confirm({
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      getContainer: () => contentRef.current as HTMLElement,
      className: `hookModal dark`,
      title: '确认删除返图内容',
      content: <div>仅删除关联返图，不会删除原AI创作，可在我的-AI创作查看</div>,
      okText: '确定',
      bodyStyle: {
        zIndex: 1200,
      },
      onOk: async close => {
        try {
          const res = await deleteAction({
            variables: {
              aiArtworkId: product?.id,
            },
          })
          if (res.data?.squareModule?.status) {
            onSuccess?.()
            close()
            message.destroy()
            onCancel()
            message.success('删除成功')
          }
        } catch (error) {
          message.destroy()
          message.error(graphQLErrorMessage(error) || '删除失败')
        }
      },
      onCancel: close => {
        close()
      },
    })
  }
  return (
    <MyModal
      open={visible}
      dark
      width={'100%'}
      onCancel={() => onCancel()}
      footer={null}
      bodyStyle={{
        padding: 24,
        height: 'calc(100vh - 48px)',
        overflow: 'hidden',
      }}
      destroyOnClose
      zIndex={1001}
      className={styles.detailsModal}
      wrapClassName={styles.detailsModalWrap}
      maskStyle={{ backgroundColor: '#000' }}
    >
      <div
        className="flex items-center flex-col"
        style={{ height: 'calc(100% - 48px)' }}
        ref={contentRef}
      >
        <img
          className="h-full rounded-[8px] object-contain"
          src={product?.artWorkUrl || ''}
          alt=""
        />
        {store.userinfo?.base?.uid === product?.userInfo?.uid && (
          <MyBtn
            $dark
            className="w-[163px] mt-6 !border-neutral-200 !bg-neutral-200 !text-neutral-900"
            onClick={handleDelete}
          >
            删除图片
          </MyBtn>
        )}
      </div>
    </MyModal>
  )
})
